import React, { useEffect, useState } from "react";
import { Form, Select } from "antd";
import {
  OrganizationListAction,
  selectedOrganizationList,
  selectedUserList,
} from "../../../actions/admin";
import organizatonLogo from "../../../images/icon/organization.png";
import { useDispatch, useSelector } from "react-redux";
import {
  getOrganizationByUserId,
  UserOrganizationListAction,
} from "../../../actions/user";

// Define interface for pagination params
interface PaginationParams {
  page?: number;
  limit?: number;
}

interface listingInitialData {
  dataToSet: any;
  pageName?: string;
  keyName: string;
  idType: string;
  isReporting?: boolean;
  apiType?: string; // this is for the budget type admin or leader/ user
  apiEndpointId?: string;
  userRole?: number; // this is for the create user isReporting functionality
  open?: any;
}

const { Option } = Select;

const OrganizationListing: React.FC<listingInitialData> = ({
  dataToSet,
  pageName,
  keyName,
  idType,
  isReporting,
  apiType,
  apiEndpointId,
  userRole,
  open,
}) => {
  const [data, setData] = useState<any[]>([]);
  const [form] = Form.useForm();
  const dispatch: any = useDispatch();
  const [loading, setLoading] = useState<boolean>(true);
  const [organizationData, setOrganizationData] = useState<any[]>([]);
  const [hasInitializedData, setHasInitializedData] = useState(false); // ✅ Track initialization
  const [stateMange, setStateManage] = useState(false);
  const handleRefresh = useSelector(
    (state: any) => state?.General?.updateListing
  );
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 7,
    total: 0,
    totalPages: 0,
  });

  useEffect(() => {
    setData(() => {
      return [];
    });
    setHasInitializedData(false); // ✅ Reset initialization flag
  }, [userRole]);

  const isMulti = ["createUser", "budget"]; // to insure if you want to select multiple orgaizations or not
  const isDisabled = ["editBudget", "editDataEntry"];

  const getSelectedOrganizations = async (id) => {
    if (idType === "user") {
      setLoading(true);
      dispatch(
        selectedUserList(id, (resp: any) => {
          setLoading(false);
          if (isMulti.includes(pageName)) {
            setOrganizationData(resp?.data?.organizationAssignment);

            const oldData = [
              ...data,
              ...(resp?.data?.organizationAssignment?.map(
                (data) => data?.organization
              ) || []),
            ];
            const uniqueOrganizations = oldData?.filter(
              (value, index, self) =>
                index === self.findIndex((org) => org.id === value.id)
            );
            setData(uniqueOrganizations);
            setHasInitializedData(true);
            setStateManage(!stateMange);
          } else {
            const oldData = [
              ...data,
              ...(resp?.data?.parentOrganization || []),
            ];
            const uniqueOrganizations = oldData?.filter(
              (value, index, self) =>
                index === self.findIndex((org) => org?.id === value?.id)
            );
            setData(uniqueOrganizations);
            setHasInitializedData(true);
            setStateManage(!stateMange);
          }
          // setData((prevData) => [...prevData, ...(resp?.data?.organizationAssignment?.map((data) => data?.organization) || [])]);
        })
      );
    } else if (idType === "organization") {
      setLoading(true);
      dispatch(
        selectedOrganizationList(id, (resp: any) => {
          setLoading(false);
          if (isMulti.includes(pageName)) {
            setOrganizationData(resp?.data?.organizationAssignment);

            const oldData = [
              ...data,
              ...(resp?.data?.organizationAssignment?.map(
                (data) => data?.organization
              ) || []),
            ];
            const uniqueOrganizations = oldData?.filter(
              (value, index, self) =>
                index === self.findIndex((org) => org?.id === value?.id)
            );
            setData(uniqueOrganizations);
            setHasInitializedData(true);
          } else {
            const oldData = [...data, resp.data?.parentOrganization];
            const uniqueOrganizations = oldData?.filter(
              (value, index, self) =>
                index === self.findIndex((org) => org?.id === value?.id)
            );
            setData(uniqueOrganizations);
            setHasInitializedData(true);
          }
          // setData((prevData) => [...prevData, ...(resp?.data?.organizationAssignment?.map((data) => data?.organization) || [])]);
        })
      );
    }
  };

  // ✅ Separate useEffect for handling dataToSet changes
  useEffect(() => {
    if (dataToSet?.id && idType !== "dataEntry" && open === true) {
      getSelectedOrganizations(dataToSet?.id);
    } else {
      setHasInitializedData(true); // ✅ Mark as initialized even if no dataToSet
    }
  }, [dataToSet?.id, idType, pageName, open]);

  // Fetches the list of organizations with optional query parameters
  const fetchOrganizationList = (params: any) => {
    setLoading(true);
    if (idType === "dataEntry" || apiType === "user") {
      dispatch(
        UserOrganizationListAction(params, (resp: any) => {
          setLoading(false);
          if (resp?.status === 200) {
            const oldData = [...data, ...(resp.data || [])];
            const uniqueOrganizations = oldData?.filter(
              (value, index, self) =>
                index === self.findIndex((org) => org.id === value.id)
            );
            setData(uniqueOrganizations);
            // setData((prevData) => [...prevData, ...(resp.data || [])]);
            // }
            setPagination({
              ...pagination,
              total: resp.pagination?.totalItems,
              current: resp.pagination?.currentPage,
              pageSize: resp.pagination?.pageSize,
              totalPages: resp.pagination?.totalPages,
            });
          }
        })
      );
    } else if (dataToSet?.id && idType === "budget") {
      setData(dataToSet?.organization ? [dataToSet.organization] : []);
    } else if (idType === "userOrg") {
      dispatch(
        getOrganizationByUserId(apiEndpointId, (resp: any) => {
          setLoading(false);
          if (resp?.status === 200) {
            const oldData = [...data, ...(resp.data || [])];
            const uniqueOrganizations = oldData?.filter(
              (value, index, self) =>
                index === self.findIndex((org) => org.id === value.id)
            );
            setData(uniqueOrganizations);
            // setData((prevData) => [...prevData, ...(resp.data || [])]);
            // }
            setPagination({
              ...pagination,
              total: resp.pagination?.totalItems,
              current: resp.pagination?.currentPage,
              pageSize: resp.pagination?.pageSize,
              totalPages: resp.pagination?.totalPages,
            });
          }
        })
      );
    } else {
      if (isReporting && userRole === 4) {
        setData([]);
        params.Organization_IsReporting = 0;
      }
      dispatch(
        OrganizationListAction(params, (resp: any) => {
          setLoading(true);
          if (resp?.status === 200) {
            let oldData = [];

            const currentPage = resp.pagination.currentPage;

            if (userRole === 4) {
              oldData = [
                ...(isReporting && currentPage === 1 ? [] : data),
                ...(resp.data || []),
              ];
            } else {
              oldData = [
                ...(currentPage === 1 ? [] : data),
                ...(resp.data || []),
              ];
            }
            // console.log(data, oldData, resp.data);
            const uniqueOrganizations = oldData?.filter(
              (value, index, self) =>
                index === self.findIndex((org) => org.id === value.id)
            );

            setData(uniqueOrganizations);
            setLoading(false);
            // setData((prevData) => [...prevData, ...(resp.data || [])]);
            // }
            setPagination({
              ...pagination,
              total: resp.pagination?.totalItems,
              current: resp.pagination?.currentPage,
              pageSize: resp.pagination?.pageSize,
              totalPages: resp.pagination?.totalPages,
            });
          }
        })
      );
    }
  };

  // Load initial data
  useEffect(() => {
    fetchOrganizationList({
      page: 1,
      limit: pagination.pageSize,
    });
  }, [
    handleRefresh,
    dataToSet?.organization,
    dataToSet?.id,
    stateMange,
    userRole,
  ]);

  // Handle onPopupScroll event for the Select component
  const handleSelectScroll = (e: React.UIEvent<HTMLDivElement>) => {
    // Check if user has scrolled to the bottom
    const { target } = e;
    if (
      !loading &&
      target instanceof HTMLElement &&
      target.scrollTop + target.offsetHeight >= target.scrollHeight - 20 &&
      pagination.current < pagination.totalPages
    ) {
      // Load next page
      const nextPage = pagination.current + 1;
      fetchOrganizationList({
        page: nextPage,
        limit: pagination.pageSize,
      });
    }
  };

  return (
    <div className="mb-[20px]">
      <Form.Item
        name={keyName}
        rules={
          keyName === "divisionOf"
            ? []
            : [{ required: true, message: "Please select an organization" }]
        }
      >
        <Select
          // mode="multiple"
          mode={isMulti.includes(pageName) ? "multiple" : undefined} // ✅ Conditionally enable multiple mode
          placeholder={
            pageName === "createOrganization"
              ? "Division Of"
              : "Select Organization"
          }
          className="input-main-col focus:bg-transparent rounded-[5px] mb-[10px] p-[10px] border-1 border-transparent focus:border-white w-full bg-[#013351] placeholder-[#005A90] color-[#fff] h-auto"
          onPopupScroll={handleSelectScroll}
          // loading={loading}
          notFoundContent={loading ? "Loading..." : "No data found"}
          listHeight={200}
          allowClear // ✅ Allows users to clear selections
          // showSearch
          disabled={isDisabled.includes(pageName)}
        >
          {data?.map((org) => (
            <Option
              key={org?.id}
              value={org?.id}
              style={{
                backgroundColor: "#013351",
                border: "none",
              }}
            >
              <div
                style={{ display: "flex", flexDirection: "row", gap: "2px" }}
              >
                <img
                  src={
                    org?.logo
                      ? org.logo
                      : dataToSet?.divisionOf === null ||
                        dataToSet?.divisionOf === " "
                      ? ""
                      : organizatonLogo
                  }
                  alt={org?.name}
                  style={{
                    width: 28,
                    marginRight: 5,
                    objectFit: "cover",
                    borderRadius: "1px",
                  }}
                />
                {org?.name}
              </div>
            </Option>
          ))}
        </Select>
      </Form.Item>
    </div>
  );
};

export default OrganizationListing;
